var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDriving = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 16,
  viewBox: "0 0 24 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.1 11v2H7.9v-2zm.5-11 3 5H24v8h-4.1v-2H22V7H2v4h1.1v2H0V5.6L4.5 0zM9 2H5.5L3.1 5H9zm5.4 0H11v3h5.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 9C7.4 9 9 10.6 9 12.5S7.4 16 5.5 16 2 14.4 2 12.5 3.6 9 5.5 9m0 2c-.8 0-1.5.7-1.5 1.5S4.7 14 5.5 14 7 13.3 7 12.5 6.3 11 5.5 11M17.5 9c1.9 0 3.5 1.6 3.5 3.5S19.4 16 17.5 16 14 14.4 14 12.5 15.6 9 17.5 9m0 2c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5"
})));
export default SvgDriving;